import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import SecondaryResourcesCategoryView from "./SecondaryResourcesCategoryView"
import Secondary2TBL from "../images/secondary-2-literary.jpg"
import Secondary2TBS from "../images/secondary-2-science.jpg"
import ZipLogo from "../images/zip.svg"

class Secondary2Resources extends React.Component {
  state = {
    view: {
      title: "Secondary 2 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Secondary2TBL,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G11-Secondary-2-Literary-TB_WM_2022.pdf",
          file2: Secondary2TBS,
          filePath2:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G11-Secondary-2-Science-TB_WM_2022.pdf",
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [
            {
              name: "Secondary 2 Audio (Literary)",
              file: "grade-11-literary-audio.zip",
            },
            {
              name: "Secondary 2 Audio (Science)",
              file: "Secondary-2-audio-(Science).zip",
            },
          ],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <SecondaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Secondary2Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesSecondary2.js